import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-screening-confirmation',
  templateUrl: './security-screening-confirmation.component.html',
  styleUrls: ['./security-screening-confirmation.component.scss']
})
export class SecurityScreeningConfirmationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
